<svelte:options />

<script>

    import ResourceHolder from './ResourceHolder.svelte';
    import { onDestroy, onMount } from 'svelte';
    import { UID } from '@repo/config/Utils';
    import { page } from '$app/state';
    import { COLLECTION_TYPES } from '@repo/content-db';
    import BookCollectionAccordianItem from '../BookCollectionAccordianItem.svelte';
    /**
     * @typedef {Object} Props
     * @property {any} [items]
     * @property {boolean} [disabled]
     * @property {any} [level]
     * @property {Set<string> | null} [hiddenIds]
     * @property {boolean} [parentHidden]
     */
    let { items = [], disabled = false, level = null, hiddenIds = null, parentHidden = false } = $props();

    let message = $derived('');
    let currentItem = $state('');
    let resourceItems = $state([]);

    const id = 'rh_' + UID();

    $effect(() => {
        const documentId = page?.params?.documentId;
        if (documentId) {
            currentItem = documentId;
        }
    });

    function getDataTitle(objData) {
        const keywords = objData.keywords || '';
        const orderMatch = keywords.match(/order:[0-9]{1,3}/gi);
        if (orderMatch) {
            return (
                orderMatch[0]
                    .split(':')[1]
                    .padStart(4, '0') +
                '_' +
                objData.title
            );
        }
        if (/page/gi.test(objData.catalog)) return 'A ' + objData.title;
        if (/presentation/gi.test(objData.catalog)) return 'B ' + objData.title;
        if (objData._collection === COLLECTION_TYPES.COLLECTIONS) return 'Z ' + objData.title.toLowerCase();
        return 'O ' + objData.title.toLowerCase();
    }

    function reorderChildren() {
        const nodeArr = [];
        const p = document.getElementById(id);
        if (p) {
            while (p.children.length > 0)
                nodeArr.push(p.removeChild(p.children.item(0)));
            nodeArr.sort((a, b) =>
                a.dataset.title < b.dataset.title ? -1 : 1
            );
            nodeArr.forEach((n) => p.appendChild(n));
        }
    }

    // monitor children and re-order
    const observer = new MutationObserver((e) => {
        if (e[0].addedNodes.length > 0) reorderChildren();
    });

    onMount(() => {
        const tar = document.getElementById(id);
        if (tar) {
            observer.observe(tar, { childList: true });
            reorderChildren();
        }
    });

    onDestroy(() => {
        observer.disconnect();
    });

    export {
        items,
        disabled,
    };
</script>

<!-- Resource Hub -->
<div class="resource-hub">
    <div class="resource-hub-body">
        {#if message.length > 0}
            <span class="no-resources">{message}</span>
        {/if}
        <ul {id} class="resources">
            {#each items as r, i}
                <li
                    class="resource-holder {currentItem === r.id
                        ? 'active'
                        : ''}"
                    class:collection-group={r._collection === COLLECTION_TYPES.COLLECTIONS}
                    data-title={getDataTitle(r)}
                    data-id={r.id}
                >
                    {#if r._collection === COLLECTION_TYPES.COLLECTIONS}
                        <BookCollectionAccordianItem
                            data={r}
                            activeItem={false}
                            level={level !== null ? level + 1 : null}
                            currentHiddenIds={hiddenIds}
                            {parentHidden}
                        />
                    {:else}
                        <ResourceHolder
                            bind:data={items[i]}
                            active={currentItem === r.id}
                            {disabled}
                            isHidden={hiddenIds?.has?.(r.id) === true}
                            {parentHidden}
                        />
                    {/if}
                </li>
            {/each}
        </ul>
    </div>
</div>

<style>
    /* Resource Hub */
    .resource-hub {
        display: flex;
        flex-direction: column;
        background-color: #000;
        padding-top: 0.5rem;
    }

    .resource-hub-body {
        display: flex;
        flex-direction: column;
        flex-grow: 10;
        color: #ddd;
    }

    .resource-holder {
        margin: 0 0.5rem 0.5rem;
    }

    .resource-holder:last-of-type {
        margin-bottom: 0.5rem;
    }

    .resource-holder.armed {
        margin-bottom: 0.5rem;
    }

    .resource-holder.active {
        margin-right: 0;
    }
    .resources {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .no-resources {
        font-size: 0.85rem;
        font-style: italic;
        color: #ddd;
    }
</style>
